import { render, staticRenderFns } from "./Organizaciones.vue?vue&type=template&id=5c304c1e&scoped=true&"
import script from "./Organizaciones.vue?vue&type=script&lang=ts&"
export * from "./Organizaciones.vue?vue&type=script&lang=ts&"
import style0 from "./Organizaciones.vue?vue&type=style&index=0&id=5c304c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c304c1e",
  null
  
)

export default component.exports